<template>
  <div id="app">
    <HeaderUSA v-if="COUNTRY_CODE === 'US'" />
    <HeaderCanada v-if="COUNTRY_CODE === 'CA'" />
    <v-app
      id="inspire"
      style="
        background-image: linear-gradient(black, #00587d);
        box-shadow: inset 0px 0px 0 2000px rgba(0, 88, 125, 0.5);
      "
    >
      <router-view></router-view>
    </v-app>
    <FooterUSA v-if="COUNTRY_CODE === 'US'" />
    <FooterCanada v-if="COUNTRY_CODE === 'CA'" />
  </div>
</template>

<script>
import HeaderUSA from "./components/FixedComponents/HeaderUSA";
import FooterUSA from "./components/FixedComponents/FooterUSA";
import HeaderCanada from "./components/FixedComponents/HeaderCanada";
import FooterCanada from "./components/FixedComponents/FooterCanada";
import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "App",
  components: {
    HeaderUSA,
    FooterUSA,
    HeaderCanada,
    FooterCanada,
  },
  computed: {    
    ...mapGetters({
      COUNTRY_CODE: types.COUNTRYCODE,
    }),
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #0a0804;
  margin: 0%;
  min-height: 100vh;
  image-rendering: -webkit-optimize-contrast;
  font-weight: bold;
}

#inspire {
  padding-top: 120px;
}

html,
body {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}

</style>
